import { clientBase } from '@/api/httpAxios'

export function routeBuild(
  url: string,
  options: { [k: string]: string | number } = {}
) {
  let result = url
  for (const [key, value] of Object.entries(options)) {
    result = result.replace(`:${key}`, value.toString())
  }
  return result
}

export function buildURL(
  url: string,
  options: { [k: string]: string | number } = {}
) {
  return `${clientBase}${routeBuild(url, options)}`
}
